import FormControlLabel from '@material-ui/core/FormControlLabel';
import Slider from '@material-ui/lab/Slider';
import * as React from 'react';
import { stylesheet } from "typestyle";

const css = stylesheet({
	container: {
		width: '150px'
	},
})
export default class OxygenLimits extends React.Component<{
	store: any
}>{

	handleChange = (event: React.ChangeEvent, value: number) => {
		this.props.store.updatedOxygenMinimum(value)
	};


	render() {
		const { store } = this.props;

		return (
			<div>
				<FormControlLabel className={css.container}
					control={
						<Slider min={40} max={140} step={1} value={store.oxygenMinimum} aria-labelledby="label" onChange={this.handleChange} />
					}
					label={store.oxygenMinimum}
				/>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/OxygenLimits.tsx